import { dynamicPageQuery } from "../../services/dynamicPageQueries";

// The "xp" Dynamic Page records behind Engage XP. Kept out of the page modules
// so the route loaders can start them without waiting for the pages' chunks.
export const XP_CATEGORY = "xp";
export const XP_MISSIONS_CONTENT_PAGE = "other-content";
export const XP_OVERVIEW_PAGE = "overview";
export const XP_FAQ_PAGE = "faq";

export const xpContentQuery = (name) => dynamicPageQuery(XP_CATEGORY, name);
